import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard, Loader2, Mail, MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { euro, formatApiErrorDetail } from "@/lib/format";
import { usePlatform, waLink } from "@/lib/usePlatform";
import { Button } from "@/components/ui/button";

// Pulsante «Continua»: abbonamento con carta se attivo, altrimenti contatti dell'assistenza.
export const ContinueActions = ({ company, dark = false, isAdmin = true }) => {
  const platform = usePlatform();
  const [offer, setOffer] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/company/subscription-offer").then((r) => setOffer(r.data)).catch(() => setOffer({ payment_enabled: false })); }, []);
  const subject = encodeURIComponent(`Attivazione K Gestionale - ${company?.ragione_sociale || ""}`);

  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/company/subscription-checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); setBusy(false); }
  };

  if (!offer) return <Loader2 className="w-5 h-5 animate-spin mx-auto text-muted-foreground" />;
  if (offer.payment_enabled && !isAdmin) return (
    <p className={`text-sm ${dark ? "text-slate-300" : "text-muted-foreground"}`} data-testid="continue-ask-owner">Chiedi al titolare della ditta di attivare l'abbonamento.</p>
  );
  if (offer.payment_enabled) return (
    <div className="space-y-2" data-testid="continue-subscription">
      <Button className="h-11 w-full sm:w-auto" onClick={pay} disabled={busy} data-testid="continue-subscribe-button">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><CreditCard className="w-4 h-4 mr-2" /> Continua con l'abbonamento</>}
      </Button>
      <div className={`text-xs ${dark ? "text-slate-400" : "text-muted-foreground"}`} data-testid="continue-subscription-price">
        {euro(offer.price)} al mese, IVA inclusa · disdici quando vuoi
      </div>
    </div>
  );
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-center" data-testid="continue-contacts">
      {platform.support_email && (
        <Button asChild className="h-11" data-testid="continue-contact-email">
          <a href={`mailto:${platform.support_email}?subject=${subject}`}><Mail className="w-4 h-4 mr-2" /> Scrivici per continuare</a>
        </Button>
      )}
      {platform.support_whatsapp && (
        <Button asChild variant="secondary" className="h-11" data-testid="continue-contact-whatsapp">
          <a href={waLink(platform.support_whatsapp)} target="_blank" rel="noreferrer"><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp</a>
        </Button>
      )}
    </div>
  );
};

export default ContinueActions;
